export interface SchoolYearDates {
  startDate: string;
  endDate: string;
}

export interface AssessmentCalendarPeriod {
  periodIdentifier: number;
  startDate: string;
  endDate: string;
}

export interface AssessmentCalendar {
  periods?: AssessmentCalendarPeriod[];
}

/**
 * Determines school year start and end dates from assessment calendar periods
 * @param assessmentCalendar - The assessment calendar containing periods
 * @returns Object with startDate and endDate strings, or null if periods unavailable
 */
export function getSchoolYearFromAssessmentCalendar(
  assessmentCalendar: AssessmentCalendar | null | undefined
): SchoolYearDates | null {
  if (!assessmentCalendar?.periods?.length) {
    return null;
  }

  // Sort periods by periodIdentifier to ensure correct order (create copy first to avoid mutating Redux state)
  const sortedPeriods = [...assessmentCalendar.periods].sort(
    (a, b) => a.periodIdentifier - b.periodIdentifier
  );
  
  const firstPeriod = sortedPeriods[0];
  const lastPeriod = sortedPeriods[sortedPeriods.length - 1];

  return {
    startDate: firstPeriod.startDate,
    endDate: lastPeriod.endDate,
  };
} 